import {useState} from 'react';
import {useRegisterSW} from 'virtual:pwa-register/react';
import {useTranslation} from 'react-i18next';
export function Offline({busy,beforeUpdate}:{busy:boolean;beforeUpdate:()=>void}){
 const {t}=useTranslation();const [dismissed,setDismissed]=useState(false);
 const {offlineReady:[ready,setReady],needRefresh:[refresh,setRefresh],updateServiceWorker}=useRegisterSW();
 if(dismissed||(!ready&&!refresh))return null;
 return <div className="offline-notice" role="status"><span>{t(refresh?'update':'offline')}</span>{refresh&&<button disabled={busy} onClick={()=>{beforeUpdate();void updateServiceWorker(true);}}>{t('refresh')}</button>}<button aria-label={t('close')} onClick={()=>{setReady(false);setRefresh(false);setDismissed(true);}}>{t('later')}</button></div>;
}
